/**
 * @generated SignedSource<<3ac5680e0af48398d92296072b0ec10c>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
export type AuditSubjectType = "AGENT_TOKEN" | "API_ACCESS_TOKEN" | "AUTHORIZATION" | "CLUSTER" | "CLUSTER_PERMISSION" | "CLUSTER_QUEUE" | "CLUSTER_QUEUE_TOKEN" | "CLUSTER_TOKEN" | "JOB" | "NOTIFICATION_SERVICE" | "ORGANIZATION" | "ORGANIZATION_BANNER" | "ORGANIZATION_INVITATION" | "ORGANIZATION_MEMBER" | "PIPELINE" | "PIPELINE_SCHEDULE" | "PIPELINE_TEMPLATE" | "REGISTRY" | "SCM_PIPELINE_SETTINGS" | "SCM_REPOSITORY_HOST" | "SCM_SERVICE" | "SECRET" | "SSO_PROVIDER" | "SUBSCRIPTION" | "SUITE" | "SUITE_MONITOR" | "TEAM" | "TEAM_MEMBER" | "TEAM_PIPELINE" | "TEAM_REGISTRY" | "TEAM_SUITE" | "USER" | "USER_EMAIL" | "USER_TOTP" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type subjectSection_auditEvent$fragmentType: FragmentType;
export type subjectSection_auditEvent$data = {|
  +subject: ?{|
    +name: ?string,
    +node: ?{|
      +name?: string,
    |},
    +type: ?AuditSubjectType,
    +uuid: string,
  |},
  +$fragmentType: subjectSection_auditEvent$fragmentType,
|};
export type subjectSection_auditEvent$key = {
  +$data?: subjectSection_auditEvent$data,
  +$fragmentSpreads: subjectSection_auditEvent$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "subjectSection_auditEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Organization",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Pipeline",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Registry",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Team",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuditEvent",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "c6df35ca11d5c2b1b75b15304f04b3b3";

module.exports = ((node/*: any*/)/*: Fragment<
  subjectSection_auditEvent$fragmentType,
  subjectSection_auditEvent$data,
>*/);
